export default "__VITE_ASSET__BDA8W8rz__"